import { Shape, ShapeOptions } from "../Shape";
import { SVGParsedPathData } from "../../../svg";
import { YZCanvasContext } from "../canvas";

export class ArrowShape extends Shape {
  constructor(options?: ShapeOptions) {
    super(options);
  }

  protected cloneShape(): ArrowShape {
    const shape = new ArrowShape({
      ...super.getBaseOptions()
    });
    return shape;
  }

  public toSVGPathData(): SVGParsedPathData[] {
    return [
      ["m", -50, -25],
      ["l", 50, 0],
      ["l", 0, -25],
      ["l", 50, 50],
      ["l", -50, 50],
      ["l", 0, -25],
      ["l", -50, 0],
      ["l", 0, -50],
      ["z"]
    ];
  }

  public toCanvasContext(ctx: YZCanvasContext) {
    ctx.beginPath();
    ctx.moveTo(-50, -25);
    ctx.lineTo(0, -25);
    ctx.lineTo(0, -50);
    ctx.lineTo(50, 0);
    ctx.lineTo(0, 50);
    ctx.lineTo(0, 25);
    ctx.lineTo(-50, 25);
    ctx.lineTo(-50, -25);
    ctx.closePath();
  }
}

export default ArrowShape;
